module.exports = __webpack_public_path__ + "fonts/source-sans-pro-v21-latin-700.ba89f89c.ttf";